import { render, staticRenderFns } from "./ManageFeatureFlags.vue?vue&type=template&id=7c70a3ba&scoped=true&"
import script from "./ManageFeatureFlags.vue?vue&type=script&lang=ts&"
export * from "./ManageFeatureFlags.vue?vue&type=script&lang=ts&"
import style0 from "./ManageFeatureFlags.vue?vue&type=style&index=0&id=7c70a3ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c70a3ba",
  null
  
)

export default component.exports